import { Alert, AlertDescription } from "@/components/ui/alert";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useTenant } from "@/providers/session";
import { useNavigate } from "@tanstack/react-router";
import { AlertTriangle, ChevronRight, X } from "lucide-react";
import { useState } from "react";

export const DebtorsWarningBanner = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { companySlug } = useTenant();

  const handleNavigateToDebtors = () => {
    setIsDialogOpen(false);
    navigate({
      to: "/$company/buchhaltung/einstellungen/debitoren",
      params: { company: companySlug },
    });
  };

  return (
    <>
      <Alert className="border rounded-lg py-2 px-2 bg-amber-50 border-amber-200 text-amber-800">
        <AlertDescription className="flex items-center justify-between ml-0 pl-2">
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 flex-shrink-0" />
            <span className="text-sm font-medium">
              Bitte Debitoren-Stammdaten prüfen
            </span>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="h-auto py-1 px-3 text-sm font-medium flex-shrink-0 text-amber-800 border-amber-300 hover:text-amber-900 hover:bg-amber-100 hover:border-amber-400 gap-1"
            onClick={() => setIsDialogOpen(true)}
          >
            Weitere Infos
            <ChevronRight className="w-4 h-4" />
          </Button>
        </AlertDescription>
      </Alert>

      <AlertDialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <AlertDialogContent className="max-w-2xl">
          <button
            onClick={() => setIsDialogOpen(false)}
            className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </button>
          <AlertDialogTitle className="text-xl">
            Bitte prüfen Sie die Debitoren-Stammdaten
          </AlertDialogTitle>
          <AlertDialogDescription className="text-base text-foreground space-y-4">
            <p>
              Es kann sein, dass ihre Debitorenstammdaten nicht mehr aktuell
              sind, wenn...
            </p>
            <ul className="space-y-2 ml-4">
              <li className="flex items-start gap-2">
                <span className="text-lg leading-none mt-0.5">•</span>
                <span>Sie kürzlich neue Debitoren in DATEV erstellt haben</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-lg leading-none mt-0.5">•</span>
                <span>Sie bisher noch keine Debitoren importiert haben</span>
              </li>
            </ul>
            <p>
              Bitte prüfen Sie, ob alle Debitoren vorhanden sind. Falls nicht
              können Sie diese auf der Seite{" "}
              <span className="font-semibold">"Debitoren"</span> über{" "}
              <span className="font-semibold">
                "Geschäftspartner importieren"
              </span>{" "}
              ergänzen.
            </p>
            <p>Falls nichts fehlt, können Sie diese Warnung ignorieren.</p>
          </AlertDialogDescription>
          <AlertDialogFooter className="gap-2">
            <AlertDialogCancel onClick={() => setIsDialogOpen(false)}>
              Abbrechen
            </AlertDialogCancel>
            <AlertDialogAction onClick={handleNavigateToDebtors}>
              Debitoren prüfen
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
